import { Text } from 'components';

export default function PlanStat({
  head,
  value,
}: {
  head: string;
  value?: string;
}) {
  return (
    <div className="w-1/3 flex flex-col items-center gap-1">
      <Text
        fontWeight="font-semibold"
        textColor="text-neutral-550"
        fontSize={10}
      >
        {head}
      </Text>
      <Text fontWeight="font-bold" textColor="text-neutral-700" fontSize={10}>
        {value}
      </Text>
    </div>
  );
}
